/* global axios */
import ApiClient from './ApiClient';

class AgentBotQualifiersAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  qualifiersUrl(botId) {
    return `${this.url}/${botId}/qualifiers`;
  }

  getAll(botId) {
    return axios.get(this.qualifiersUrl(botId));
  }

  createQualifier(botId, data) {
    return axios.post(this.qualifiersUrl(botId), data);
  }

  updateQualifier(botId, qualifierId, data) {
    return axios.put(`${this.qualifiersUrl(botId)}/${qualifierId}`, data);
  }

  deleteQualifier(botId, qualifierId) {
    return axios.delete(`${this.qualifiersUrl(botId)}/${qualifierId}`);
  }

  complete(botId, qualifierId, { dealId, result, data }) {
    return axios.post(`${this.qualifiersUrl(botId)}/${qualifierId}/complete`, {
      deal_id: dealId,
      result,
      data,
    });
  }
}

export default new AgentBotQualifiersAPI();
